import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, X, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function OnboardingChecklist({ tasks = [] }) {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => localStorage.getItem("onboarding_dismissed") === "1");
  const isFree = user && user.role !== "admin" && !user.personal_active && !user.snap_active && !user.business_active;
  if (!isFree || hidden) return null;

  const hasReminder = tasks.some((t) => t.kind === "task");
  const completed = tasks.some((t) => t.kind === "task" && t.completed);
  const steps = [
    { id: "add", label: "Add your first reminder", done: hasReminder, hint: "Tap “Quick add”." },
    { id: "complete", label: "Check one off", done: completed, hint: "Tick the box when it's done." },
    { id: "calendar", label: "See it on your Pulse calendar", done: false, to: "/pricing", hint: "Unlocks with Individual." },
    { id: "budget", label: "Try SnapBudget", done: false, to: "/snapbudget", hint: "Your 4-week money map." },
  ];
  const doneCount = steps.filter((s) => s.done).length;
  const dismiss = () => { localStorage.setItem("onboarding_dismissed", "1"); setHidden(true); };

  return (
    <div data-testid="onboarding-checklist" className="border border-[var(--line)] bg-white mb-8">
      <div className="flex items-center justify-between p-5 border-b border-[var(--line)]">
        <h3 className="font-serif text-xl tracking-tight flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-[var(--accent)]" /> Your first week
        </h3>
        <div className="flex items-center gap-3">
          <span className="label-mono text-[var(--text-2)]">{doneCount}/{steps.length} done</span>
          <button data-testid="onboarding-dismiss" onClick={dismiss} className="text-[var(--text-2)] hover:text-[var(--danger)]"><X className="w-4 h-4" /></button>
        </div>
      </div>
      <ul className="divide-y divide-[var(--line)]">
        {steps.map((s) => (
          <li key={s.id} className="flex items-center gap-3 px-5 py-3">
            <span className={`w-5 h-5 rounded-full grid place-items-center shrink-0 ${s.done ? "bg-[var(--accent)] text-white" : "border-2 border-[var(--text-2)]"}`}>
              {s.done && <Check className="w-3 h-3" strokeWidth={3} />}
            </span>
            <div className="min-w-0 flex-1">
              <p className={`text-sm font-medium ${s.done ? "line-through text-[var(--text-2)]" : ""}`}>{s.label}</p>
              <p className="text-xs text-[var(--text-2)]">{s.hint}</p>
            </div>
            {!s.done && s.to && <Link to={s.to} className="text-xs text-[var(--accent)] hover:underline whitespace-nowrap">Open</Link>}
          </li>
        ))}
      </ul>
    </div>
  );
}
